export const generatedApiTags = [
	'Chat',
	'Client',
	'LabResults',
	'Measurement',
	'Range',
	'Panel',
	'SpecialRule',
	'User'
]